import script from "./CoinList.vue?vue&type=script&setup=true&lang=js"
export * from "./CoinList.vue?vue&type=script&setup=true&lang=js"

import "./CoinList.vue?vue&type=style&index=0&id=a7ea8692&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7ea8692"]])

export default __exports__